module.exports = __webpack_public_path__ + "static/media/icon-pet-plastic.20a51923.png";